import axios from 'axios';

const baseURL = 'api/PerfilEmpresarial';

async function getData(user) {
        const { data } = await axios.get(baseURL + "/datos?language=" + user.language + "&idUsuario=" + user.id,
            {
                headers: {
                    'token': user.token
                }
            });
        return data;

}


async function getActual(usuario, language) {
    const { data } = await axios.get(baseURL + "/actual?idUsuario=" + usuario.id + "&language=" + language,
    {
        headers: {
            'token': usuario.token
        }
    }
    );
    return data;
}

export default { getData, getActual }